import {
  Svg,
  type SvgProps,
} from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import { type FunctionComponent } from 'react';

export const OtherDot: FunctionComponent<SvgProps> = (props) => (
  <Svg
    optimizationId="iconFamilyB2CPromo"
    viewBox="0 0 102 103"
    {...props}
    width="24"
    height="24"
    fill="none"
  >
    <circle cx="51.125" cy="51" r="50.5" fill="#fff" stroke="#ECEDF0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.958 54.667a3.667 3.667 0 1 1 0-7.333 3.667 3.667 0 0 1 0 7.333Zm-12.833 0a3.667 3.667 0 1 1 0-7.333 3.667 3.667 0 0 1 0 7.333Zm-16.5-3.666a3.667 3.667 0 1 0 7.333 0 3.667 3.667 0 0 0-7.333 0Z"
      fill="#8B91A1"
    />
  </Svg>
);
